(function ($, Drupal, drupalSettings) {
  'use strict';

  jQuery.validator.addMethod("validate_email", function(value, element) {

    if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
      return true;
    } else {
      return false;
    }
  }, "Please enter a valid email");

  /*inicializamos scripts para que cargen en cuando finalice la carga del DOM */
  $(document).ready(function () {

    //Json con los prefijos de telefono de cada pais
    const countryPrefix = {
      '1': '93',
      '10': '43',
      '100': '596',
      '101': '230',
      '102': '222',
      '103': '52',
      '104': '373',
      '105': '976',
      '106': '382',
      '107': '258',
      '108': '264',
      '109': '977',
      '11': '994',
      '110': '505',
      '111': '227',
      '112': '234',
      '113': '47',
      '114': '64',
      '115': '968',
      '116': '92',
      '117': '970',
      '118': '507',
      '119': '595',
      '12': '973',
      '120': '51',
      '121': '48',
      '122': '351',
      '123': '1-787',
      '124': '974',
      '125': '44',
      '126': '243',
      '128': '420',
      '13': '880',
      '130': '1-809',
      '131': '250',
      '132': '40',
      '133': '7',
      '134': '212',
      '135': '685',
      '136': '221',
      '137': '381',
      '138': '232',
      '139': '65',
      '14': '1-246',
      '140': '963',
      '141': '94',
      '142': '27',
      '143': '249',
      '144': '46',
      '145': '41',
      '146': '597',
      '147': '66',
      '148': '886',
      '149': '66',
      '15': '32',
      '150': '228',
      '151': '216',
      '152': '993',
      '153': '90',
      '154': '380',
      '155': '256',
      '156': '598',
      '157': '998',
      '158': '58',
      '159': '84',
      '16': '501',
      '160': '967',
      '161': '260',
      '162': '263',
      '163': '1-268',
      '164': '229',
      '165': '238',
      '166': '235',
      '167': '269',
      '168': '850',
      '169': '291',
      '17': '375',
      '170': '245',
      '171': '592',
      '172': '95',
      '173': '960',
      '174': '244',
      '175': '379',
      '176': '423',
      '177': '377',
      '179': '675',
      '18': '591',
      '180': '236',
      '181': '224',
      '182': '378',
      '183': '239',
      '184': '248',
      '185': '252',
      '186': '268',
      '187': '992',
      '188': '670',
      '189': '1-868',
      '19': '387',
      '192': '1-264',
      '193': '672',
      '194': '599',
      '196': '297',
      '198': '1-242',
      '199': '1-441',
      '2': '355',
      '20': '267',
      '200': '47',
      '201': '1-345',
      '202': '61',
      '204': '61',
      '205': '242',
      '206': '682',
      '208': '599',
      '209': '253',
      '21': '55',
      '210': '1-767',
      '211': '298',
      '212': '679',
      '213': '350',
      '214': '1-473',
      '215': '590',
      '216': '44-1481',
      '219': '672',
      '22': '673',
      '220': '246',
      '221': '44',
      '222': '358',
      '223': '500',
      '224': '680',
      '225': '686',
      '226': '853',
      '227': '500',
      '228': '1-670',
      '229': '692',
      '23': '359',
      '230': '262',
      '231': '691',
      '232': '1-664',
      '233': '674',
      '234': '683',
      '235': '672',
      '236': '687',
      '237': '64',
      '238': '689',
      '239': '677',
      '24': '226',
      '240': '1-684',
      '241': '590',
      '242': '1-869',
      '243': '508',
      '244': '1-784',
      '245': '290',
      '246': '1-758',
      '248': '211',
      '249': '47',
      '25': '257',
      '252': '690',
      '253': '1-649',
      '254': '688',
      '255': '678',
      '256': '1-284',
      '257': '1-340',
      '258': '681',
      '26': '975',
      '27': '855',
      '28': '237',
      '29': '1',
      '3': '49',
      '30': '56',
      '31': '86',
      '32': '357',
      '33': '57',
      '34': '82',
      '35': '225',
      '36': '506',
      '37': '385',
      '38': '53',
      '39': '45',
      '4': '376',
      '40': '593',
      '41': '20',
      '42': '503',
      '43': '971',
      '44': '421',
      '45': '386',
      '46': '34',
      '47': '1',
      '48': '372',
      '49': '251',
      '5': '966',
      '50': '63',
      '51': '358',
      '52': '33',
      '53': '241',
      '54': '220',
      '55': '995',
      '56': '233',
      '57': '30',
      '58': '299',
      '59': '1-671',
      '6': '213',
      '60': '502',
      '61': '594',
      '62': '240',
      '63': '509',
      '64': '31',
      '65': '504',
      '66': '852',
      '67': '36',
      '68': '91',
      '69': '62',
      '7': '54',
      '70': '98',
      '71': '964',
      '72': '353',
      '73': '354',
      '74': '972',
      '75': '39',
      '76': '1-876',
      '77': '81',
      '78': '962',
      '79': '7',
      '8': '374',
      '80': '254',
      '81': '996',
      '83': '965',
      '84': '856',
      '86': '266',
      '87': '371',
      '88': '961',
      '89': '231',
      '9': '61',
      '90': '218',
      '91': '370',
      '92': '352',
      '93': '389',
      '94': '261',
      '95': '60',
      '96': '265',
      '97': '223',
      '98': '356',
      '99': '212',
    };

    var tiposCurso = null;
    var jsonFile = null;
    var tipoCursoUrl = null;

    var match = null;

    if (drupalSettings.language === 'es'){
      tiposCurso = {
        'espanol-adultos': 'Adultos',
        'espanol-ninos-adolescentes': 'Niños y Adolescentes',
        'clases-privadas-espanol': 'Clases Privadas',
        'espanol-empresas-organizaciones': 'Empresas / Instituciones',
        'arabe-hispanohablantes': 'Hispanohablantes - Árabe',
        'ingles-hispanohablantes': 'Hispanohablantes - Inglés',
        'hispanohablantes-formacion-profesores': 'Hispanohablantes - Profesores',
        'arabe': 'Otros Cursos - Árabe',
        'idioma-ingles': 'Otros Cursos - Inglés',
      };
      jsonFile = 'studies-dubai-es.json';
      match = window.location.pathname.match(/\/estudios\/([\w-]+)/);
    }else{
      tiposCurso = {
        'spanish-adults': 'Adults',
        'spanish-children-teens': 'Children and Teens',
        'spanish-private-classes': 'Private Classes',
        'spanish-corporates-institutions': 'Corporate / Institutions',
        'arabic-spanish-speakers': 'Spanish speakers - Arabic',
        'english-spanish-speakers': 'Spanish speakers - English',
        'teacher-training-spanish-speakers': 'Spanish speakers - Teacher Training',
        'arabic': 'Other Courses - Arabic',
        'language-english': 'Other Courses -  English course',
      };
      jsonFile = 'studies-dubai-en.json';
      match = window.location.pathname.match(/\/studies\/([\w-]+)/);
    }
    if(match){
      tipoCursoUrl = tiposCurso[match[1]];
    }


    /*****************************
     *****FORMULARIO CABECERA*****
     *****************************/

    var tipoCursoSelect = $('#tipoCurso');
    var cursoSelect = $('#curso');
    var modalidadSelect = $('#modalidad');
    if (tipoCursoUrl) {
      tipoCursoSelect.parent().css("display", "none");
    }

    var estudios = null;
    //Al hacer click en el botón solicita información recogemos los estudios, si no se han recogido ya
    $("[data-target='#solicitaInformacion']").click(function (event) {
      if (estudios == null && $("#solicitaInformacion").length > 0) {
        getStudies();
      }
    });

    //Obtenemos los estudios de un json
    function getStudies() {
      var urlStudies = drupalSettings.base_url + '/sites/spanish.ucam.ae/files/json/' + jsonFile;
      $('.sk-fading-circle').show();
      $.ajax({
        url: urlStudies,
        method: 'get',
        success: (results) => {
          estudios = results;
          Object.entries(estudios).forEach(entry => {
            const [key, value] = entry;
            var option = document.createElement("OPTION");
            option.value = key;
            option.text = key;
            tipoCursoSelect.append(option);
          });
          var option = document.createElement("OPTION");
          option.value = 'ninguno';
          option.text = Drupal.t('Others');
          tipoCursoSelect.append(option);

          if (tipoCursoUrl) {
            $('#tipoCurso').val(tipoCursoUrl).trigger('change');
          }
          $('.sk-fading-circle').hide();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $('.modal-body').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          $('.sk-fading-circle').hide();
          $('#closeModalForm').removeClass('d-none');
          $('.modal-footer').addClass('d-none');
        }
      });
    }

    //Al cambiar el país del formulario
    $('#country').change(function () {
      var pais = $('option:selected', this).val();
      //Desactivamos la provincia si no es España
      if (pais == 46) {
        $('#province').parent().css("display", "block");
        $('#country').parent().removeClass('col-md-12');
      } else {
        $('#province').val("");
        $('#province').parent().css("display", "none");
        $('#country').parent().addClass('col-md-12');
      }
      //Cambiamos el prefijo de telefono
      if (countryPrefix[pais]) {
        $('#tlf-prefix').text('+' + countryPrefix[pais]);
      } else {
        $('#tlf-prefix').text('+');
      }
    });

    var cursos = [];
    //Al cambiar el tipo de curso
    $('#tipoCurso').change(function () {
      //Recogemos el select tipo de curso
      var tipoCurso = $(this).val();

      var groupCurso = $('#group-curso');

      if (tipoCurso != 'ninguno') {
        //Borramos todos las opciones del select menos la primera, que es la que viene por defecto
        while (cursoSelect.children().length > 1) {
          cursoSelect.children().last().remove();
        }

        //Borramos todos las opciones del select menos la primera, que es la que viene por defecto
        while (modalidadSelect.children().length > 1) {
          modalidadSelect.children().last().remove();
        }
        //Filtramos los estudios según el idioma seleccionado
        if (tipoCurso) {
          cursos = estudios[tipoCurso];
        }

        //Recorremos los estudios filtrados y los añadimos
        if (Object.keys(cursos).length == 1) {
          var curso = Object.keys(cursos)[0];
          var option = document.createElement("OPTION");
          option.value = curso;
          option.text = curso;
          cursoSelect.append(option);
          cursoSelect.val(option.value).trigger('change');
        } else {
          for (const curso in cursos) {
            var option = document.createElement("OPTION");
            option.value = curso;
            option.text = curso;
            cursoSelect.append(option);
          }
        }
        //Si el tipo de curso no se selecciona, se pone el campo curso en desactivado
        if (tipoCurso !== '') {
          cursoSelect.removeAttr('disabled');
          if (cursoSelect.val() === '') {
            cursoSelect.val('').trigger('change');
          }
        } else {
          cursoSelect.val('').trigger('change');
          cursoSelect.attr('disabled', true);
        }

        //Se muestra el curso al no haber seleccionado el tipo estudio ninguno
        groupCurso.css("display", "block");

        //Si se selecciona ninguno  se oculta el curso y se añade la linea de estudio 904 por defecto.
      } else {
        groupCurso.css("display", "none");

        while (cursoSelect.children().length > 1) {
          cursoSelect.children().last().remove();
        }
        while (modalidadSelect.children().length > 1) {
          modalidadSelect.children().last().remove();
        }

        modalidadSelect.removeAttr('disabled');
        var option = document.createElement("OPTION");
        option.value = drupalSettings.default_line;
        option.text = '';
        modalidadSelect.append(option);
        modalidadSelect.val(option.value);
      }
    });

    var modalidadesFiltradas = [];
    //Al cambiar el curso
    $('#curso').change(function () {
      //Recogemos el curso
      var curso = $(this).val();

      //Borramos todos las opciones del select menos la primera, que es la que viene por defecto
      while (modalidadSelect.children().length > 1) {
        modalidadSelect.children().last().remove();
      }
      //Filtramos las modalidades según el curso seleccionado
      if (curso) {
        modalidadesFiltradas = cursos[curso];
      }

      //Recorremos las modalidades filtradas y las añadimos
      if (modalidadesFiltradas.length === 1) {
        var modalidad = modalidadesFiltradas[0];
        var option = document.createElement("OPTION");
        option.value = modalidad.Line;
        option.text = modalidad.Name;
        modalidadSelect.append(option);
        modalidadSelect.val(option.value);
      } else {
        modalidadesFiltradas.forEach(modalidad => {
          var option = document.createElement("OPTION");
          option.value = modalidad.Line;
          option.text = modalidad.Name;
          modalidadSelect.append(option);
        })
      }
      //Si el curso no se selecciona, se pone la modalidad en desactivado
      if (curso !== '') {
        modalidadSelect.removeAttr('disabled');
      } else {
        modalidadSelect.val('');
        modalidadSelect.attr('disabled', true);
      }
    });


    //Al enviar el formulario, lo validamos y lo enviamos a CRM //
    $('#formSolicitaInformacionDubai').submit(function (e) {
      e.preventDefault();
    }).validate(
      {
        errorClass: "error",
        highlight: function (element, errorClass, validClass) {
          $(element).addClass(errorClass).removeClass(validClass);
          if (element.type === "checkbox") {
            $(element).parent().addClass("field-error");
          }
          if (element.type === "radio") {
            $(element).parent().parent().find("label").addClass("field-error");
          }
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).addClass(validClass).removeClass(errorClass);
          if (element.type === "checkbox") {
            $(element).parent().removeClass("field-error");
          }
          if (element.type === "radio") {
            $(element).parent().parent().find("label").removeClass("field-error");
          }
        },
        rules: {
          name: {required: true, maxlength: 50},
          lastname: {required: true, maxlength: 50},
          email: {required: true, validate_email: true, maxlength: 90},
          country: {required: true},
          tlf: {required: true, digits: true, maxlength: 40},
          observation: {maxlength: 450},
          tipoCurso: {required: true},
          curso: {
            required: function () {
              return ($('#tipoCurso').val() != 'ninguno' && $('#tipoCurso').val() != '') ? true : false;
            }
          },
          line: {
            required: function () {
              return ($('#curso').val() != '') ? true : false;
            }
          },
          inputTerms: {required: true},
          province: {
            required: function (element) {
              //SI ES ESPAÑA
              return $("#country").val() == 46 ? true : false;
            }
          },
        },
        messages: {
          name: {required: Drupal.t("* Obligatory field"), maxlength: Drupal.t("Max length is 50 characters")},
          lastname: {required: Drupal.t("* Obligatory field"), maxlength: Drupal.t("Max length is 50 characters")},
          email: {
            validate_email: Drupal.t("*Must be an e-mail address"),
            required: Drupal.t("* Obligatory field"),
            maxlength: Drupal.t("Max length is 90 characters")
          },
          country: Drupal.t("* Obligatory field"),
          tlf: {
            digits: Drupal.t("*Must be a number"),
            required: Drupal.t("* Obligatory field"),
            maxlength: Drupal.t("Max length is 40 characters")
          },
          observation: {maxlength: Drupal.t("Max length is 450 characters")},
          tipoCurso: Drupal.t("* Obligatory field"),
          curso: Drupal.t("* Obligatory field"),
          line: Drupal.t("* Obligatory field"),
          province: Drupal.t("* Obligatory field"),
          inputTerms: "*",
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function (form, e) {
          sendAjaxInfo(form);
        }
      });

    function sendAjaxInfo() {
      $('.sk-fading-circle').show();
      $.ajax({
        url: "https://wscrm.ucam.edu/lead",
        method: 'post',
        dataType: 'json',
        data: $('#formSolicitaInformacionDubai').serialize().replace('tlf=', 'tlf=%2B' + $('#tlf-prefix').text().replace('+', '')),
        success: function (result) {
          var code = result.STATUS;
          if (code == 200) {
            $('#formSolicitaInformacionDubai .modal-title').text(Drupal.t("Thank You!"));
            $('#formSolicitaInformacionDubai .modal-body').html('<div class="alert alert-success text-center" role="alert">' + Drupal.t("We have received your request for information. <br> You will receive an email shortly.") + '</div>');
          } else if (code == 500) {
            $('#formSolicitaInformacionDubai .modal-body').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          } else {
            $('#formSolicitaInformacionDubai .modal-body').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          }
          $('.sk-fading-circle').hide();
          $('#closeModalForm').removeClass('d-none');
          $('.modal-footer').addClass('d-none');
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $('#formSolicitaInformacionDubai .modal-body').html('<div class="alert alert-warning text-center" role="alert">' + Drupal.t("We are sorry. <br> We are currently having trouble picking up your application. <br> Please try again later or contact info@ucam.edu <br> Thank you.") + '</div>');
          $('.sk-fading-circle').hide();
          $('#closeModalForm').removeClass('d-none');
          $('.modal-footer').addClass('d-none');
        }
      });
    }

    /**
     * Panel deslizante de términos y condidiones. Si pulsamos en el icono "i" se abre
     * Si pulsamos en el boton X se cierra
     */
    $('.js--terms-conditions-link').click(function () {
      $('#solicitaInformacion #termsConditionsContent').removeClass('closed');
    });
    $('#solicitaInformacion #termsConditionsContent .close').click(function () {
      $('#solicitaInformacion #termsConditionsContent').addClass('closed');
    });


  });
})(jQuery, Drupal, drupalSettings);
